import React from "react"
import { newsletterBG } from "../../assets"

const NewsLetter = () => {
  return (
    <div className="relative flex items-center justify-center">
      <img src={newsletterBG} className="w-full" alt="" />
      <div className="absolute flex flex-col justify-center items-center inset-0">
        <p className="font-inter leading-none text-[25px] xl:text-[30px] font-[600] tracking-[3px] text-[#f9f9f9]">
          PLACEA NEWSLETTER
        </p>
        <p className="text-[16px] xl:text-[18px] mt-[8px] xl:mt-[10px] mb-[15px] xl:mb-[18px] font-[600] leading-none tracking-[1.7px] text-white">
          Let Us Plan Your Perfect Getaway
        </p>
        <div className="flex items-center justify-center gap-[18px] xl:gap-[26px]">
          <button
            style={{ border: "3px solid #FFF" }}
            className="rounded-[15px] px-[20px] xl:px-[25px] py-[6px] xl:py-[10px] font-inter text-[15px] xl:text-[18px] font-[600] text-white"
          >
            LEARN MORE
          </button>
          <button
            style={{ border: "3px solid #AB0101" }}
            className="rounded-[15px] bg-[#AB0101] px-[20px] xl:px-[25px] py-[6px] xl:py-[10px] font-inter text-[15px] xl:text-[18px] font-[600] text-white"
          >
            SUBSCRIBE
          </button>
        </div>
      </div>
    </div>
  )
}

export default NewsLetter
